import { AnyAction, EntityId, ThunkDispatch } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FavoritesReducerStateShape } from '@cp/entities/client/current/favorite';
import { useApiServerErrorHandler } from 'src/shared/apiServer';
import { toggleFavoriteThunk } from './toggleFavoriteThunk';

export const useToggleFavorite = (clientId: EntityId) => {
  const dispatch: ThunkDispatch<FavoritesReducerStateShape, unknown, AnyAction> = useDispatch();
  const handleApiServerError = useApiServerErrorHandler();

  return useCallback(async () => {
    const result = await dispatch(toggleFavoriteThunk(clientId));
    if ('error' in result) {
      handleApiServerError(result.error);
    }
  }, [clientId, dispatch, handleApiServerError]);
};
